import { useMutation, UseMutationOptions } from "@tanstack/react-query"

import { httpClient } from "~/backend/axios"

type UploadCustomFieldProofRequestDto = {
  operationId: number
  customFieldValueId: string
  file: File
}

export function useUploadCustomFieldProof(
  options?: UseMutationOptions<any, any, UploadCustomFieldProofRequestDto>
) {
  return useMutation({
    mutationFn: async (data: UploadCustomFieldProofRequestDto) => {
      const formData = new FormData()
      formData.append("file", data.file)
      formData.append("operationId", data.operationId.toString())
      formData.append("customFieldValueId", data.customFieldValueId)
      const response = await httpClient.post(
        "/v1/custom-field/upload-custom-field-proof",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      return response.data
    },
    ...options,
  })
}
